// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as UpgradeSuccessRouteImport } from './routes/upgrade-success'
import { Route as UpgradeErrorRouteImport } from './routes/upgrade-error'
import { Route as TermsRouteImport } from './routes/terms'
import { Route as StatsRouteImport } from './routes/stats'
import { Route as SignupRouteImport } from './routes/signup'
import { Route as SetupRouteImport } from './routes/setup'
import { Route as SettingsRouteImport } from './routes/settings'
import { Route as ResetPasswordRouteImport } from './routes/reset-password'
import { Route as PrivacyRouteImport } from './routes/privacy'
import { Route as ManageRouteImport } from './routes/manage'
import { Route as LoginRouteImport } from './routes/login'
import { Route as GrowthRouteImport } from './routes/growth'
import { Route as ForgotPasswordRouteImport } from './routes/forgot-password'
import { Route as DocsRouteImport } from './routes/docs'
import { Route as DashboardRouteImport } from './routes/dashboard'
import { Route as AgentRouteImport } from './routes/agent'
import { Route as IndexRouteImport } from './routes/index'
import { Route as FoundersIndexRouteImport } from './routes/founders/index'
import { Route as CategoriesIndexRouteImport } from './routes/categories/index'
import { Route as BlogIndexRouteImport } from './routes/blog/index'
import { Route as FoundersFounderSlugRouteImport } from './routes/founders/$founderSlug'
import { Route as CategoriesCategoryRouteImport } from './routes/categories/$category'
import { Route as BlogSlugRouteImport } from './routes/blog/$slug'
import { Route as AgentsAgentSlugRouteImport } from './routes/agents/$agentSlug'
import { Route as AdminUsersRouteImport } from './routes/admin/users'
import { Route as AdminFeedbackRouteImport } from './routes/admin/feedback'
import { Route as AdminAgentsRouteImport } from './routes/admin/agents'
import { Route as AdminAdsRouteImport } from './routes/admin/ads'
import { Route as DocsIndexRouteImport } from './routes/docs/index'
import { Route as DocsSubmitRouteImport } from './routes/docs/submit'
import { Route as DocsCapabilitiesRouteImport } from './routes/docs/capabilities'
import { Route as DashboardIndexRouteImport } from './routes/dashboard/index'
import { Route as DashboardManageRouteImport } from './routes/dashboard/manage'
import { Route as DashboardFounderRouteImport } from './routes/dashboard/founder'
import { Route as DashboardAgentsRouteImport } from './routes/dashboard/agents'
import { Route as ApiAuthErrorRouteImport } from './routes/api/auth/error'

const UpgradeSuccessRoute = UpgradeSuccessRouteImport.update({
            id: '/upgrade-success',path: '/upgrade-success',getParentRoute: () => rootRouteImport
          })
const UpgradeErrorRoute = UpgradeErrorRouteImport.update({
            id: '/upgrade-error',path: '/upgrade-error',getParentRoute: () => rootRouteImport
          })
const TermsRoute = TermsRouteImport.update({
            id: '/terms',path: '/terms',getParentRoute: () => rootRouteImport
          })
const StatsRoute = StatsRouteImport.update({
            id: '/stats',path: '/stats',getParentRoute: () => rootRouteImport
          })
const SignupRoute = SignupRouteImport.update({
            id: '/signup',path: '/signup',getParentRoute: () => rootRouteImport
          })
const SetupRoute = SetupRouteImport.update({
            id: '/setup',path: '/setup',getParentRoute: () => rootRouteImport
          })
const SettingsRoute = SettingsRouteImport.update({
            id: '/settings',path: '/settings',getParentRoute: () => rootRouteImport
          })
const ResetPasswordRoute = ResetPasswordRouteImport.update({
            id: '/reset-password',path: '/reset-password',getParentRoute: () => rootRouteImport
          })
const PrivacyRoute = PrivacyRouteImport.update({
            id: '/privacy',path: '/privacy',getParentRoute: () => rootRouteImport
          })
const ManageRoute = ManageRouteImport.update({
            id: '/manage',path: '/manage',getParentRoute: () => rootRouteImport
          })
const LoginRoute = LoginRouteImport.update({
            id: '/login',path: '/login',getParentRoute: () => rootRouteImport
          })
const GrowthRoute = GrowthRouteImport.update({
            id: '/growth',path: '/growth',getParentRoute: () => rootRouteImport
          })
const ForgotPasswordRoute = ForgotPasswordRouteImport.update({
            id: '/forgot-password',path: '/forgot-password',getParentRoute: () => rootRouteImport
          })
const DocsRoute = DocsRouteImport.update({
            id: '/docs',path: '/docs',getParentRoute: () => rootRouteImport
          })
const DashboardRoute = DashboardRouteImport.update({
            id: '/dashboard',path: '/dashboard',getParentRoute: () => rootRouteImport
          })
const AgentRoute = AgentRouteImport.update({
            id: '/agent',path: '/agent',getParentRoute: () => rootRouteImport
          })
const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const FoundersIndexRoute = FoundersIndexRouteImport.update({
            id: '/founders/',path: '/founders/',getParentRoute: () => rootRouteImport
          })
const CategoriesIndexRoute = CategoriesIndexRouteImport.update({
            id: '/categories/',path: '/categories/',getParentRoute: () => rootRouteImport
          })
const BlogIndexRoute = BlogIndexRouteImport.update({
            id: '/blog/',path: '/blog/',getParentRoute: () => rootRouteImport
          })
const FoundersFounderSlugRoute = FoundersFounderSlugRouteImport.update({
            id: '/founders/$founderSlug',path: '/founders/$founderSlug',getParentRoute: () => rootRouteImport
          })
const CategoriesCategoryRoute = CategoriesCategoryRouteImport.update({
            id: '/categories/$category',path: '/categories/$category',getParentRoute: () => rootRouteImport
          })
const BlogSlugRoute = BlogSlugRouteImport.update({
            id: '/blog/$slug',path: '/blog/$slug',getParentRoute: () => rootRouteImport
          })
const AgentsAgentSlugRoute = AgentsAgentSlugRouteImport.update({
            id: '/agents/$agentSlug',path: '/agents/$agentSlug',getParentRoute: () => rootRouteImport
          })
const AdminUsersRoute = AdminUsersRouteImport.update({
            id: '/admin/users',path: '/admin/users',getParentRoute: () => rootRouteImport
          })
const AdminFeedbackRoute = AdminFeedbackRouteImport.update({
            id: '/admin/feedback',path: '/admin/feedback',getParentRoute: () => rootRouteImport
          })
const AdminAgentsRoute = AdminAgentsRouteImport.update({
            id: '/admin/agents',path: '/admin/agents',getParentRoute: () => rootRouteImport
          })
const AdminAdsRoute = AdminAdsRouteImport.update({
            id: '/admin/ads',path: '/admin/ads',getParentRoute: () => rootRouteImport
          })
const DocsIndexRoute = DocsIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => DocsRoute
          })
const DocsSubmitRoute = DocsSubmitRouteImport.update({
            id: '/submit',path: '/submit',getParentRoute: () => DocsRoute
          })
const DocsCapabilitiesRoute = DocsCapabilitiesRouteImport.update({
            id: '/capabilities',path: '/capabilities',getParentRoute: () => DocsRoute
          })
const DashboardIndexRoute = DashboardIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => DashboardRoute
          })
const DashboardManageRoute = DashboardManageRouteImport.update({
            id: '/manage',path: '/manage',getParentRoute: () => DashboardRoute
          })
const DashboardFounderRoute = DashboardFounderRouteImport.update({
            id: '/founder',path: '/founder',getParentRoute: () => DashboardRoute
          })
const DashboardAgentsRoute = DashboardAgentsRouteImport.update({
            id: '/agents',path: '/agents',getParentRoute: () => DashboardRoute
          })
const ApiAuthErrorRoute = ApiAuthErrorRouteImport.update({
            id: '/api/auth/error',path: '/api/auth/error',getParentRoute: () => rootRouteImport
          })





const DashboardRouteChildren = {
  DashboardAgentsRoute: DashboardAgentsRoute,DashboardFounderRoute: DashboardFounderRoute,DashboardManageRoute: DashboardManageRoute,DashboardIndexRoute: DashboardIndexRoute
}

const DashboardRouteWithChildren = DashboardRoute._addFileChildren(DashboardRouteChildren)




const DocsRouteChildren = {
  DocsCapabilitiesRoute: DocsCapabilitiesRoute,DocsSubmitRoute: DocsSubmitRoute,DocsIndexRoute: DocsIndexRoute
}

const DocsRouteWithChildren = DocsRoute._addFileChildren(DocsRouteChildren)

const rootRouteChildren = {
  IndexRoute: IndexRoute,AgentRoute: AgentRoute,DashboardRoute: DashboardRouteWithChildren,DocsRoute: DocsRouteWithChildren,ForgotPasswordRoute: ForgotPasswordRoute,GrowthRoute: GrowthRoute,LoginRoute: LoginRoute,ManageRoute: ManageRoute,PrivacyRoute: PrivacyRoute,ResetPasswordRoute: ResetPasswordRoute,SettingsRoute: SettingsRoute,SetupRoute: SetupRoute,SignupRoute: SignupRoute,StatsRoute: StatsRoute,TermsRoute: TermsRoute,UpgradeErrorRoute: UpgradeErrorRoute,UpgradeSuccessRoute: UpgradeSuccessRoute,AdminAdsRoute: AdminAdsRoute,AdminAgentsRoute: AdminAgentsRoute,AdminFeedbackRoute: AdminFeedbackRoute,AdminUsersRoute: AdminUsersRoute,AgentsAgentSlugRoute: AgentsAgentSlugRoute,BlogSlugRoute: BlogSlugRoute,CategoriesCategoryRoute: CategoriesCategoryRoute,FoundersFounderSlugRoute: FoundersFounderSlugRoute,BlogIndexRoute: BlogIndexRoute,CategoriesIndexRoute: CategoriesIndexRoute,FoundersIndexRoute: FoundersIndexRoute,ApiAuthErrorRoute: ApiAuthErrorRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)